/**
 * @since 7.1.0
 */
export var CalendarSourceType;
(function (CalendarSourceType) {
    /**
     * @since 7.1.0
     */
    CalendarSourceType[CalendarSourceType["LOCAL"] = 0] = "LOCAL";
    /**
     * @since 7.1.0
     */
    CalendarSourceType[CalendarSourceType["EXCHANGE"] = 1] = "EXCHANGE";
    /**
     * @since 7.1.0
     */
    CalendarSourceType[CalendarSourceType["CAL_DAV"] = 2] = "CAL_DAV";
    /**
     * @since 7.1.0
     */
    CalendarSourceType[CalendarSourceType["MOBILE_ME"] = 3] = "MOBILE_ME";
    /**
     * @since 7.1.0
     */
    CalendarSourceType[CalendarSourceType["SUBSCRIBED"] = 4] = "SUBSCRIBED";
    /**
     * @since 7.1.0
     */
    CalendarSourceType[CalendarSourceType["BIRTHDAYS"] = 5] = "BIRTHDAYS";
})(CalendarSourceType || (CalendarSourceType = {}));
//# sourceMappingURL=calendar-source-type.js.map